'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export const useScrollToTopOnRouteChange = () => {
  const pathname = usePathname()

  useEffect(() => {
    const scrollToTopWithUnlock = () => {
      const html = document.documentElement
      const isLocked = html.classList.contains('scroll-lock')
      let prevScrollY = 0

      // scroll was locked with @patrianna/shared-hooks/useScrollLock for mobile devices
      if (isLocked) {
        const stored = html.style.getPropertyValue('--scrollY').replace('px', '')
        prevScrollY = stored ? Number(stored) : html.scrollTop
        html.classList.remove('scroll-lock')
        html.scrollTop = prevScrollY // to prevent shifts after scroll unlock
        html.style.removeProperty('--scrollY')
      }

      window.scrollTo(0, 0)
      html.scrollTop = 0

      if (isLocked) {
        html.style.setProperty('--scrollY', '0px')
        html.classList.add('scroll-lock')
      }
    }

    requestAnimationFrame(() => {
      scrollToTopWithUnlock()
    })
  }, [pathname])
}
